<ng-template #sharedDialogContent>
    <div class="countable-dialog confirmation-dailog deleteConfirmDialog">
        <div mat-dialog-title class="dialog-header">
            <span class="badge badge-warning badge-circle icon-bordered-warning text-center">
                <i class="fa-regular"
                   [ngClass]="{'fa-triangle-exclamation': data.type === DIALOG_TYPES.RESET , 'fa-trash-can text-error': data.type === DIALOG_TYPES.SCHEDULE }"></i>
            </span>

            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>

        <div mat-dialog-content class="dialog-body-content">
            <h4 class="title text-center mr-2 px-3">{{ data.headerText }}</h4>
            @if (data.subHeaderText) {
                <p class="fw-medium">{{ data.subHeaderText }}</p>
            }
            @if (data.errorText) {
                <p class="text-warning-darker fw-medium">{{ data.errorText }}</p>
            }
            @if (data.subInfoText) {
                <p class="text-gray-6">{{ data.subInfoText }}</p>
            }
            @if (isScheduleConfirmedDelete()) {
                <mat-form-field class="fixed-label label-none w-100 col-des"
                                floatLabel="always">
                    <input [formControl]="deleteFormControl" matInput type="text"
                           placeholder="Delete"
                           class="cash-field">
                </mat-form-field>
            }
        </div>

        <div mat-dialog-actions class="dialog-footer">
            <button mat-button mat-stroked-button class="button-medium" color="dark"
                    [mat-dialog-close]="false">{{ data.buttonCancelText }}
            </button>
            <button [disabled]="(isScheduleConfirmedDelete() ? !(deleteFormControl.value === 'Delete') : false) || showSpinner()"
                    mat-button
                    mat-flat-button class="button-medium" color="error"
                    (click)="confirmDelete()">
                @if (showSpinner()) {
                    <span class="smooth-gradient-ring-s"></span>
                } @else {
                    {{ data.buttonConfirmText }}
                }
            </button>
        </div>
    </div>
</ng-template>

<ng-template #createSchedule>
    <div class="countable-dialog" (click)="$event.stopPropagation()" style="width: 471px;">
        <div mat-dialog-title class="dialog-header  d-flex flex-column align-items-center px-0">
            <button mat-button class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>
        <div mat-dialog-content class="content dialog-body-content text-left gap-8 pt-3 pb-2">
            <h4 class="title mr-2">Create Schedule</h4>
            <ng-container>
                <p class="text-gray-6">Following selected items will be added to the schedule</p>
            </ng-container>
            <form [formGroup]="scheduleForm" autocomplete="off">
                <div class="form-group my-3 w-100">
                    <mat-form-field class="form-item fixed-label w-100" floatLabel="always">
                        <mat-label>Schedule Name</mat-label>
                        <input formControlName="name" matInput maxlength="100" placeholder="Schedule Name"
                        >
                    </mat-form-field>
                    <mat-form-field class="form-item fixed-label w-100" floatLabel="always">
                        <mat-label>Line Item Name</mat-label>
                        <input formControlName="lineName" matInput maxlength="100"
                               placeholder="Line Item Name"
                        >
                    </mat-form-field>
                    @if (data.type === DIALOG_TYPES.GROUP) {
                        <div class="d-flex flex-column gap-12">
                            <label class="fw-medium">Schedule Orientation<span class="text-error">*</span></label>
                            <div class="radio-group d-flex">
                                <mat-radio-group formControlName="orientation" class="d-flex gap-20">
                                    <mat-radio-button value="Collapse">Collapse</mat-radio-button>
                                    <mat-radio-button value="Expand">Expand</mat-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>
                    }

                </div>

            </form>
            @if (data.type === DIALOG_TYPES.GROUP) {
                <div class="card overflow-auto w-100 create-scedule-tbl" id="grid">
                    <div class="flex-table fixed-header hover-action">
                        <div class="flex-table-header fixed-top">
                            <p class="ft-header-cell" style="width: 50px; max-width: 50px;">
                <span class="d-flex gap-10 align-items-center">
                  <mat-checkbox [checked]="isCheckedAll()" (change)="onAllChange($event)">
                  </mat-checkbox>

                </span>
                            </p>
                            <p class="ft-header-cell" style="width: 315px; max-width: 315px;">
                                <span>Sub-Group Categories</span>
                            </p>
                            <p class="ft-header-cell" style="width: 55px; max-width:55px;">
                                <span>LS</span>
                            </p>
                        </div>
                        <div class="flex-table-body h-100" (click)="$event.stopPropagation()">
                            @for (group of subGroups(); track group; let index = $index) {
                                <div class="ft-row button-row">
                                    <p class="ft-cell" style="width: 50px; max-width: 50px;">
                  <span class="d-flex gap-10 align-items-center">
                    <mat-checkbox [checked]="group.isChecked" (change)="onChange($event, index)">
                    </mat-checkbox>

                  </span>
                                    </p>
                                    <p class="ft-cell" style="width: 315px; max-width: 315px;">
                  <span class="d-flex align-items-center gap-10">
                    {{ group.name }}
                  </span>
                                    </p>
                                    <p class="ft-cell" style="width: 55px; max-width: 55px;">
                  <span class="d-flex align-items-center gap-10">
                   {{ group.lsCode }}
                  </span>
                                    </p>
                                </div>
                            }

                        </div>
                    </div>
                </div>
            }

        </div>
        <div mat-dialog-actions class="dialog-footer flex-column mt-3" (click)="$event.stopPropagation()">
            <div class="button-group">
                <button [disabled]="data.type === DIALOG_TYPES.GROUP ? !(data.selectedSchedule?.isValid && scheduleForm.valid && isCheckedOne()) : !scheduleForm.valid"
                        (click)="createScheduleManual()" mat-button mat-flat-button
                        class="button-medium"
                        color="primary">
                    Create
                </button>
            </div>
            @if (data.type === DIALOG_TYPES.GROUP ? !(data.selectedSchedule?.isValid) : false) {
                <p class="text-warning-darker fw-medium">Cannot create schedule as the selected line items are from
                    different leadsheets.
                    Please select the line items from same leadsheet to create schedule.</p>
            }

        </div>
    </div>
</ng-template>

@switch (data.type) {
    @case (DIALOG_TYPES.SCHEDULE) {
        <ng-container *ngTemplateOutlet="sharedDialogContent"></ng-container>
    }
    @case (DIALOG_TYPES.RESET) {
        <ng-container *ngTemplateOutlet="sharedDialogContent"></ng-container>
    }
    @case (DIALOG_TYPES.DELETE) {
        <div class="countable-dialog confirmation-dailog deleteConfirmDialog" (click)="$event.stopPropagation()">
            <div mat-dialog-title class="dialog-header">
      <span class="badge badge-error badge-circle icon-bordered-error">
        <i class="fa-regular fa-trash-can text-error"></i>
      </span>
                <h4 class="title">Delete {{ data.headerText }}</h4>
                <button color="error" class="close" [mat-dialog-close]="false">
                    <i class="fa-regular fa-xmark clear-icon"></i>
                </button>
            </div>

            <div mat-dialog-content class="dialog-body-content">
                <p class="fw-medium" [innerHtml]="data.subHeaderText"></p>
                @if (data.errorText) {
                    <p class="text-warning-darker fw-medium">{{ data.errorText }}</p>
                }
                <p class="text-gray-6" [innerHtml]="data.subInfoText"></p>
            </div>

            <div mat-dialog-actions class="dialog-footer">
                <button mat-button mat-stroked-button class="button-medium" color="dark"
                        [mat-dialog-close]="false">{{ data.buttonCancelText }}
                </button>
                <button mat-button mat-flat-button class="button-medium" color="error"
                        [mat-dialog-close]="true">{{ data.buttonConfirmText }}
                </button>
            </div>
        </div>
    }
    @case (DIALOG_TYPES.GROUP) {
        <ng-container *ngTemplateOutlet="createSchedule"></ng-container>
    }
    @case (DIALOG_TYPES.MANUAL) {
        <ng-container *ngTemplateOutlet="createSchedule"></ng-container>
    }
}
